var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var Mailbox = function (_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M4.99984 11.6667V8.33333H3.33317V16.6667H16.6665V8.33333H8.33317V6.66667H16.6665C17.1248 6.66667 17.5172 6.82986 17.8436 7.15625C18.17 7.48264 18.3332 7.875 18.3332 8.33333V16.6667C18.3332 17.125 18.17 17.5174 17.8436 17.8438C17.5172 18.1701 17.1248 18.3333 16.6665 18.3333H3.33317C2.87484 18.3333 2.48248 18.1701 2.15609 17.8438C1.8297 17.5174 1.6665 17.125 1.6665 16.6667V8.33333C1.6665 7.875 1.8297 7.48264 2.15609 7.15625C2.48248 6.82986 2.87484 6.66667 3.33317 6.66667H4.99984V1.66667H11.6665V5H6.6665V11.6667H4.99984Z", fill: color }) })));
};
